export default {
	"faqSection.searchTerm": "Frage eingeben...",
	"faqSection.search": "Suchen",
	"faqSection.notFound": "Keine Ergebnisse gefunden",
	"faqSection.targetGroup": "Für {targetGroup}",
	"faqSection.general": "Allgemein",
} as const;
